"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetsManager_1 = __importDefault(require("./WidgetsManager"));
exports.default = WidgetsManager_1.default;
